import React from "react";

/**
 * Permanent footer notice required for Google Play compliance.
 * Visible on every page, sits above the bottom safe area.
 */
const PlayStoreFooterNotice: React.FC = () => {
  return (
    <div
      role="note"
      aria-label="Aviso legal"
      className="w-full bg-muted/60 border-t border-border text-center text-[11px] sm:text-xs text-muted-foreground px-3 py-2 leading-snug"
    >
      +18 · Ferramenta estatística e de entretenimento. Este app não realiza apostas.
    </div>
  );
};

export default PlayStoreFooterNotice;
